// extracted by mini-css-extract-plugin
export default {"group":"exQHnkH_","mobile":"mobile","content":"SCkdxvWW"};